import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, noindex = false }) => {
  const { pathname } = useLocation();
  const baseURL = "https://www.tlsengenharia.com.br";
  const canonicalUrl = `${baseURL}${pathname === "/" ? "" : pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Se noindex for true, adiciona a tag de bloqueio */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default SEO;

